import { render, staticRenderFns } from "./BtnOnClassPicker.vue?vue&type=template&id=08ca9a86"
import script from "./BtnOnClassPicker.vue?vue&type=script&lang=js"
export * from "./BtnOnClassPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports